var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMigrationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.875 1.375H4.125A1.375 1.375 0 0 0 2.75 2.75V5.5a1.375 1.375 0 0 0 1.375 1.375h6.188v4.242L8.531 9.343l-.97.97L11 13.75l3.438-3.438-.97-.969-1.78 1.774V6.875h6.187A1.375 1.375 0 0 0 19.25 5.5V2.75a1.375 1.375 0 0 0-1.375-1.375zM4.125 2.75h2.75V5.5h-2.75V2.75zm13.75 2.75H8.25V2.75h9.625V5.5zM17.875 15.125H4.125A1.375 1.375 0 0 0 2.75 16.5v2.75a1.375 1.375 0 0 0 1.375 1.375h13.75a1.375 1.375 0 0 0 1.375-1.375V16.5a1.375 1.375 0 0 0-1.375-1.375zM4.125 16.5h9.625v2.75H4.125V16.5zm13.75 2.75h-2.75V16.5h2.75v2.75z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMigrationIcon);
export default __webpack_public_path__ + "static/media/migrationIcon.91da832408f332931474149da42db602.svg";
export { ForwardRef as ReactComponent };